import React, { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Image,
  addToast
} from "@heroui/react";
import { LuCheck, LuCopy, LuLogOut } from "react-icons/lu";
import { shortenAddress } from "../../../utils/common";

const AccountInfoModal = ({
  isOpen,
  onOpenChange,
  address,
  bafBalanceFormatted,
  bafBalanceSymbol,
  avatarUrl,
  modalLogout = () => {},
  walletType
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (text) => {
    if (!text || !text.trim()) {
      addToast({
        title: "Copy Error",
        description: "Nothing to copy.",
        color: "danger",
        variant: "bordered"
      });
      return;
    }

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;

        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.top = "-9999px";

        document.body.appendChild(textarea);
        textarea.select();

        const success = document.execCommand("copy");
        document.body.removeChild(textarea);

        if (!success) throw new Error("execCommand failed");
      }

      setCopied(true);
      setTimeout(() => setCopied(false), 2000);

      addToast({
        title: "Copied!",
        description: "Address copied to clipboard",
        color: "success",
        variant: "bordered"
      });
    } catch (error) {
      console.error("Copy failed:", error);

      addToast({
        title: "Copy Failed",
        description: "Unable to copy. Please copy manually.",
        color: "danger",
        variant: "bordered"
      });
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        classNames={{
          base: "bg-[#f4f4f4]",
          backdrop: "bg-[#0000004d]",
          closeButton: "hidden"
        }}
        size="sm"
        onOpenChange={onOpenChange}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody className="p-4">
                <Image
                  alt="profile"
                  src={avatarUrl}
                  classNames={{
                    wrapper:
                      "w-20 h-20 flex justify-center items-center bg-[#b6b1b6] rounded-full p-1 mx-auto !max-w-full",
                    img: "h-12 w-12 object-contain"
                  }}
                />
                <div className="flex flex-col gap-1.5">
                  <p className="m-0 text-base text-black font-medium text-center">
                    {shortenAddress(address)}
                  </p>
                  <p className="m-0 text-xs text-gray-500 font-medium text-center">
                    {bafBalanceFormatted
                      ? Number(bafBalanceFormatted)?.toFixed(2)
                      : ""}
                    {bafBalanceSymbol ? "BAF" : "BAF"}
                  </p>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="flex-1 bg-white shadow-md text-black data-[focus-visible=true]:outline-transparent"
                  color="primary"
                  onPress={() => handleCopy(address)}
                  startContent={
                    copied ? (
                      <LuCheck className="text-black w-4 h-4" />
                    ) : (
                      <LuCopy className="text-black w-4 h-4" />
                    )
                  }
                >
                  <span className="text-sm text-black font-medium">
                    {copied ? "Copied!" : "Copy Address"}
                  </span>
                </Button>
                <Button
                  className="flex-1 bg-white shadow-md text-black"
                  color="primary"
                  onPress={modalLogout}
                  startContent={<LuLogOut className="text-black w-4 h-4" />}
                >
                  <span className="text-sm text-black font-medium">
                    {walletType ? "Log Out" : "Disconnect"}
                  </span>
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default AccountInfoModal;
